<template>
  <div class="tabs-container">
    <div v-if="showBanner" class="config-banner" role="alert">
      <i class="fas fa-exclamation-triangle"></i>
      <span class="config-banner-text">
        Retention Messaging is not configured for this app! Please reach out to Cerebro developers
      </span>
    </div>

    <div class="tabs-wrapper">
      <div
        class="tab"
        :class="activeTab === 'messages' ? 'tab-active' : ''"
        @click="navigate('RetentionMessagesTab')"
      >
        Messages
      </div>
      <div
        class="tab"
        :class="activeTab === 'images' ? 'tab-active' : ''"
        @click="navigate('RetentionImagesTab')"
      >
        Images
      </div>
      <div
        v-if="isConfigured"
        class="tab"
        :class="activeTab === 'defaults' ? 'tab-active' : ''"
        @click="navigate('RetentionDefaultsTab')"
      >
        Default Messages
      </div>
      <div
        class="tab"
        :class="activeTab === 'realtime' ? 'tab-active' : ''"
        @click="navigate('RetentionRealtimeTab')"
      >
        Realtime Parameter Builder
      </div>
      <a
        class="tab tab-docs"
        :href="DOCS_URL"
        target="_blank"
        rel="noopener noreferrer"
      >
        Documentation
        <i class="fas fa-external-link-alt"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const DOCS_URL = 'https://www.notion.so/codewayco/Retention-Messaging-Documentation-3520ca597c89812798d1cd291900c63f';

export default {
  name: 'RetentionTabs',
  data() {
    return { DOCS_URL };
  },
  computed: {
    ...mapGetters('retention', ['configurationStatus', 'isConfiguredFor']),
    activeTab() {
      const name = this.$route.name;
      if (name === 'RetentionMessagesTab') return 'messages';
      if (name === 'RetentionImagesTab') return 'images';
      if (name === 'RetentionDefaultsTab' || name === 'RetentionDefaultProduct') return 'defaults';
      if (name === 'RetentionRealtimeTab') return 'realtime';
      return null;
    },
    activeApp() {
      return this.$store.getters.activeApp;
    },
    isConfigured() {
      return this.isConfiguredFor(this.activeApp);
    },
    showBanner() {
      const status = this.configurationStatus[this.activeApp];
      return !!status && status.ready === false;
    }
  },
  watch: {
    activeApp: {
      immediate: true,
      handler(appId) {
        if (appId) this.fetchConfigurationStatus(appId);
      }
    }
  },
  methods: {
    ...mapActions('retention', ['fetchConfigurationStatus']),
    navigate(name) {
      if (this.$route.name === name) return;
      this.$router.push({ name, params: { aid: this.$store.getters.activeApp } });
    }
  }
};
</script>

<style scoped>
.tabs-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.tabs-wrapper {
  background-color: rgba(25, 25, 38, 0.83);
  border-radius: 5px;
  padding: 4px 14px;
  display: flex;
  align-items: center;
  width: 100%;
}

.tab {
  color: #778CA3;
  font-size: 14px;
  line-height: 24px;
  padding: 6px 12px;
  margin: 6px 0;
  cursor: pointer;
  transition: color 0.12s ease;
}

.tab:hover {
  color: #b8c5d4;
}

.tab-active,
.tab-active:hover {
  color: #03B3DA;
  text-decoration: underline;
  pointer-events: none;
  cursor: default;
}

/* Documentation tab is an external <a>; push to the far right and strip the
   default underline + visited colour so it reads as a tab, not a link. */
.tab-docs {
  margin-left: auto;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.tab-docs:hover {
  text-decoration: none;
}

.tab-docs i {
  font-size: 11px;
  opacity: 0.7;
}

.config-banner {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.85rem 1.15rem;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid #e74c3c;
  border-radius: 6px;
  color: #e74c3c;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
}

.config-banner i {
  font-size: 20px;
  flex-shrink: 0;
}

.config-banner-text {
  white-space: normal;
}
</style>
